export function isExternalUrl(url) {
	const urlRegex = /^https?:\/\/([^\/]+)\//;
	let match = urlRegex.exec(url.toLowerCase());
	if (match) {
		return match[1] != location.host;
	}
	return false;
}

export function isFileUrl(url) {
	// Find the last file like path of the url. This most come after an `/`, and contain a `.`.
	const fileLinkRegex = /\/(([^\/\.]*)\.([^\/\.\?]+))\??[^\/\.]*$/;
	// Ensure we only affect the pathname of the URL
	let m = fileLinkRegex.exec(url.split('?')[0].toLowerCase());

	if (m) {
		return {
			name: m[1],
			extension: m[3],
		}
	}
	return null;
}

export function extractTopLevelDomain(url) {
	const urlParts = new URL(url).hostname.split('.');
	return urlParts
		.slice(0)
		.slice(-(urlParts.length === 4 ? 3 : 2))
		.join('.');
}

export function isExternalDomain(url) {
	return isExternalUrl(url) && url.indexOf(extractTopLevelDomain(location)) === -1;
}

//depends on marketing permission
export function youtubeVideoUrl() {
	if (!window.marketingPermissions) {
		return 'https://www.youtube-nocookie.com/embed/'
	}
	else {
		return 'https://www.youtube.com/embed/'
	}
}

export function trackedgNoTrackedVideoUrl(isVimeo, marketingPermissions, videoUrl) {
	if (!isVimeo) {
		if (marketingPermissions) {
			videoUrl = videoUrl.replace('youtube-nocookie', 'youtube');
		}
		else if (!videoUrl.includes('youtube-nocookie')) {
			videoUrl = videoUrl.replace('youtube', 'youtube-nocookie');
		}
	}
	else {
		const searchParam = 'dnt=true';
		if (marketingPermissions) {
			let paramsToReplace;
			if (videoUrl.includes(searchParam)) {
				//detect what sign is before 'dnt' is it '&' or '?' and remove the right part
				paramsToReplace = videoUrl[videoUrl.indexOf(searchParam) - 1];
				paramsToReplace += searchParam;
				videoUrl = videoUrl.replace(paramsToReplace, '');
			}
		}
		else {
			if (videoUrl.includes('?')) {
				videoUrl += '&' + searchParam;
			}
			else {
				videoUrl += '?' + searchParam;
			}
		}
	}
	return videoUrl;
}
